import AppInputField from "components/shared/FormComponents/AppInputField";

const QuestionReferralReason = ({ question, fieldName }) => {
  return (
    <>
      <div className="">
        <AppInputField
          name={`${fieldName}.answer`}
          placeholder={question.placeholder}
          fieldType={"textarea"}
          rows={4}
          className="form-control rounded-3 bg-white is-resizable-textarea"
        />
      </div>
      <div className="pt-3">
        <AppInputField
          name={`${fieldName}.other_details.referral_reason`}
          placeholder={"Optional"}
          fieldType={"textarea"}
          rows={4}
          className="form-control rounded-3 bg-white is-resizable-textarea"
        />
      </div>
    </>
  )
}

export default QuestionReferralReason;